import { roundToScale } from './roundToScale'

type Input = Parameters<typeof roundToScale>[0]

export const roundBillingCents = <T extends Input>(value: T) => roundToScale(value, 2)
